// Product class following the same pattern as the Admin app's class structure
const Product = {
    // Pre-defined product catalog with placeholder data
    // These will be overridden with Shopify data when available
    catalog: {
        waterSensor: {
            id: 'water-sensor',
            handle: 'water-sensor',
            title: 'Water Sensor',
            shortTitle: 'Water Sensor',
            subtitle: 'Early Leak Detection',
            features: [
                'Instant leak detection alerts',
                'Works with Smart Hub',
                '10 year long lastering battery',
                'Easy installation',
                'Monitors basements, kitchens, bathrooms'
            ],
            icon: 'fas fa-water',
            color: '#4A90E2',
        },
        bedShaker: {
            id: 'bed-shaker',
            handle: 'bed-shaker',
            title: 'Bedside Control Center',
            shortTitle: 'Bedside Control Center',
            subtitle: 'Vibration Alert System',
            features: [
                'Powerful vibration alerts for emergencies',
                'Connects to all Aqua Link alarms',
                'Ideal for heavy sleepers and hearing impaired',
                'Works with Smart Hub',
                'Adjustable vibration intensity'
            ],
            icon: 'fas fa-bed',
            color: '#4A90E2',
        },
        commLink: {
            id: 'comm-link-smart-hub',
            handle: 'comm-link-smart-hub',
            title: 'Smart Hub',
            shortTitle: 'Smart Hub',
            subtitle: 'Central Command Center',
            features: [
                'Connects all Aqua Link devices',
                'Instant push notifications',
                'Ethernet and WiFi connectivity'
            ],
            icon: 'fas fa-broadcast-tower',
            color: '#4A90E2',
        },
        starterPack: {
            id: 'starter-pack',
            handle: 'starter-pack',
            title: 'Aqua Link Base Network',
            shortTitle: 'Base Network',
            subtitle: 'Everything to get protected',
            features: [
                'Smart Hub — the brain of the network',
                '3 wireless Water Sensors for your highest-risk spots',
                'Bedside Control Center that wakes you at night',
                'No monthly fees',
            ],
            // Short "what's in the box" lines for the compact phone card
            includes: ['Smart Hub', '3 Water Sensors', 'Bedside Control Center'],
            icon: 'fas fa-box-open',
            color: '#0071E3',
            bundle: true, // excluded from the à-la-carte product grid / nav
        }
    },

    // Returns the full product catalog as an array
    getAll: () => {
        return Object.values(Product.catalog);
    },

    // Find a product by its handle/slug
    getByHandle: (handle) => {
        return Object.values(Product.catalog).find(p => p.handle === handle) || null;
    },

    // Merge Shopify product data with local catalog data
    mergeWithShopify: (localProduct, shopifyProduct) => {
        if(!shopifyProduct) {
            return localProduct;
        }
        return {
            ...localProduct,
            ...shopifyProduct,
            // Keep local fields that Shopify doesn't provide
            shortTitle: localProduct.shortTitle,
            subtitle: localProduct.subtitle,
            features: localProduct.features,
            icon: localProduct.icon,
            color: localProduct.color
        };
    }
};

export default Product;
